var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "back-to-top-container" },
    [
      _c(
        "transition",
        { attrs: { name: "fade-slide", appear: "" } },
        [
          _c(
            "v-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isVisible,
                  expression: "isVisible",
                },
              ],
              staticClass: "back-to-top-button",
              attrs: {
                "aria-label": _vm.$t(
                  "accessibility.back_to_top",
                  "Back to top of page"
                ),
                color: "accent",
                fab: "",
                fixed: "",
                bottom: "",
                right: "",
                elevation: "6",
              },
              on: {
                click: _vm.scrollToTop,
                keydown: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.scrollToTop($event)
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar",
                      ])
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.scrollToTop($event)
                  },
                ],
              },
            },
            [
              _c("v-icon", { attrs: { "aria-hidden": "true" } }, [
                _vm._v("\n        fas fa-arrow-up\n      "),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "sr-only" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "accessibility.back_to_top_description",
                        "Scroll to top of page"
                      )
                    ) +
                    "\n      "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showProgress && _vm.isVisible
        ? _c(
            "div",
            {
              staticClass: "scroll-progress",
              attrs: {
                role: "progressbar",
                "aria-valuenow": _vm.scrollProgress,
                "aria-valuemin": "0",
                "aria-valuemax": "100",
                "aria-label": _vm.$t(
                  "accessibility.scroll_progress",
                  "Page scroll progress"
                ),
              },
            },
            [
              _c("div", {
                staticClass: "progress-fill",
                style: { height: _vm.scrollProgress + "%" },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "sr-only" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(Math.round(_vm.scrollProgress)) +
                    "% scrolled\n    "
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }